export default "__VITE_ASSET__Bs1p981q__"